// import styles from "./Informacoes.module.css";

function Informacoes({ venda }) {
    const camposPersonalizados = {
        serviceId: "ID do Serviço",
        userId: "ID do Usuário",
        serviceName: "Nome do Serviço",
        serviceImage: "Imagem do Serviço",
        cycle: "Ciclo",
        firstValue: "Valor Inicial",
        value: "Valor Subscrição",
        currency: "Moeda",
        token: "Token",
        systemId: "Plano",
        purchaseDate: "Data de Compra",
        lastPayed: "Último Pagamento",
        nextDue: "Próximo Vencimento",
        cancelamento: "Cancelamento",
        status: "Status",
        description: "Descrição",
        created_at: "Criado em"
    };

    const esconderCampos = ["updated_at", "ptero", "currency"]; // currency vai ser mostrado junto com value

    function formatarValor(chave, valor, venda) {
        if (valor === null) return "Não disponível";

        if (chave.includes("Date") || chave.includes("created_at")) {
            const data = new Date(valor);
            return isNaN(data.getTime()) ? "Data inválida" : data.toLocaleDateString("pt-PT");
        }

        if (chave === "serviceImage") {
            return (
                <div style={{ marginTop: "5px" }}>
                    <br />
                    <img src={valor} alt="Imagem do serviço" width="100" style={{ borderRadius: "8px" }} />
                </div>
            );
        }

        if (chave === "value") {
            return `${valor} ${venda.currency || ""}`;
        }

        if (chave === "cancelamento") {
            if (valor === "notrequired") return "Não requerido";
            if (valor === "required") return "Requerido";
        }

        return String(valor);
    }



    return (
        <div>
            {Object.keys(venda).map((key) => {
                if (esconderCampos.includes(key)) return null;

                const label = camposPersonalizados[key] || key;
                const valorFormatado = formatarValor(key, venda[key], venda);

                return (
                    <div key={key} style={{ marginBottom: "10px" }}>
                        <strong>{label}:</strong> {valorFormatado}
                    </div>
                );
            })}
        </div>
    )
}

export default Informacoes;